import { useCallback, useState } from "react";
import bkLogo from "../../../../images/bklogo.svg";
import i18n from "../../../../utils/i18n";
import ContinueLaterPanel from "../continueLaterPanel/ContinueLaterPanel.jsx";
import classes from "./searchFlowHeader.module.scss";

const SearchFlowHeader = ({ hideContinueLater = false }) => {
  const [continueLaterOpen, setContinueLaterOpen] = useState(false);

  const openContinueLater = useCallback(() => {
    setContinueLaterOpen(true);
  }, []);

  const closeContinueLater = useCallback(() => {
    setContinueLaterOpen(false);
  }, []);

  return (
    <>
      <header className={classes.header}>
        <div className={classes.headerInner}>
          <div className={classes.logoWrap}>
            <img src={bkLogo} alt="bookkeepie" className={classes.logo} />
          </div>
          {!hideContinueLater ? (
            <button
              type="button"
              className={classes.continueLaterButton}
              onClick={openContinueLater}
            >
              {i18n.t("searchflow.continuelaterbutton")}
            </button>
          ) : null}
        </div>
      </header>
      <ContinueLaterPanel open={continueLaterOpen} onClose={closeContinueLater} />
    </>
  );
};

export default SearchFlowHeader;
